module.exports = __webpack_public_path__ + "static/sv_screenshot_high_expose-9b218a7e6261cf32503567f83f50a85f.png";